import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";



export const useGetHoliday = () => {
  return useQuery<
    AxiosResponseAndError<{date: string
      description: string}[]>["response"],
    AxiosResponseAndError<any>["error"]
  >({
    queryKey: [QUERY_KEYS.getHoliday],
    queryFn: async () => await ApiRequest.get(`${requestURLs.getHoliday}`),
    enabled: false,
  });
}